/* eslint-disable @typescript-eslint/no-unused-vars */
import { api, showErrorNotification, showSuccessNotification } from '@med-fe/util';
import { call, put } from 'redux-saga/effects';
import { updateHolidayScheduleFailure, updateHolidayScheduleSuccess } from './actions';

export function* getHolidaysFullStartWorker(action?: any): Generator {
  try {
    const url = `/holidays/full`;
    const data: any = yield call(api.get, url, true, true);

    if (action?.payload?.onSuccess) {
      yield call(action.payload.onSuccess, data);
    }

    return data;
  } catch (e: any) {
    if (action?.payload?.onError) {
      yield call(action.payload.onError, e);
    } else {
      showErrorNotification();
    }
    return null;
  }
}

export function fetchHolidaysFull(): Promise<any> {
  const url = `/holidays/full`;
  return api.get(url, true, true);
}

export function* getHolidaysSomeStartWorker(action?: any): Generator {
  try {
    const year = action?.payload?.year;

    const url = year ? `/holidays/some?year=${encodeURIComponent(year)}` : `/holidays/some`;

    const data: any = yield call(api.get, url, true, true);

    if (action?.payload?.onSuccess) {
      yield call(action.payload.onSuccess, data);
    }

    return data;
  } catch (e: any) {
    if (action?.payload?.onError) {
      yield call(action.payload.onError, e);
    } else {
      showErrorNotification();
    }
    return null;
  }
}

export function fetchHolidaysSome(year?: string | number): Promise<any> {
  const url = year ? `/holidays/some?year=${encodeURIComponent(year)}` : `/holidays/some`;

  return api.get(url, true, true);
}

export function* getRegionsStartWorker(action?: any): Generator {
  try {
    const url = `/regions`;
    const data: any = yield call(api.get, url, true, true);

    if (action?.payload?.onSuccess) {
      yield call(action.payload.onSuccess, data);
    }

    return data;
  } catch (e: any) {
    if (action?.payload?.onError) {
      yield call(action.payload.onError, e);
    } else {
      showErrorNotification();
    }
    return null;
  }
}

export function fetchRegions(positions = ''): Promise<any> {
  const url = `/regions${positions ? `?positions=${positions}` : ''}`;
  return api.get(url, true, true);
}

export function* getDistrictsStartWorker(action?: any): Generator {
  try {
    const regionId = action?.payload?.regionId;
    const url = `/districts/${regionId}`;
    const data: any = yield call(api.get, url, true, true);

    if (action?.payload?.onSuccess) {
      yield call(action.payload.onSuccess, data);
    }

    return data;
  } catch (e: any) {
    if (action?.payload?.onError) {
      yield call(action.payload.onError, e);
    } else {
      showErrorNotification();
    }
    return null;
  }
}

export function fetchDistricts(regionId: number | string, positions = ''): Promise<any> {
  const url = `/districts/${regionId}${positions ? `?positions=${positions}` : ''}`;
  return api.get(url, true, true);
}

export function fetchUpdateHolidaySchedule(request: any): Promise<any> {
  const url = `/holidays/schedule`;
  return api.put(url, request, null, true, true);
}

export function* updateHolidayScheduleStartWorker({ payload }: any): Generator {
  try {
    const url = `/holidays/schedule`;

    const data = yield call(api.put, url, payload, null, true, true);

    yield put(updateHolidayScheduleSuccess(data));

    if (data?.success) {
      showSuccessNotification('Holiday schedule updated successfully.');
    }
  } catch (e: any) {
    yield put(updateHolidayScheduleFailure(e));

    const message =
      e?.response?.data?.error?.messages?.[0] || 'Error while updating holiday schedule. Please try again.';
    showErrorNotification(message);
  }
}

export function* getHolidayLocationsStartWorker(action?: any): Generator {
  try {
    const payload = action?.payload?.request || action?.payload || {};
    const url = `/holidays/locations`;
    const data: any = yield call(api.post, url, payload, null, true, true);

    if (action?.payload?.onSuccess) {
      yield call(action.payload.onSuccess, data);
    }

    return data;
  } catch (e: any) {
    if (action?.payload?.onError) {
      yield call(action.payload.onError, e);
    } else {
      showErrorNotification();
    }
    return null;
  }
}

export function fetchHolidayLocations(
  request: { RegionId: number; DistrictIds: number[] },
  positions = ''
): Promise<any> {
  const url = `/holidays/locations${positions ? `?positions=${positions}` : ''}`;
  return api.post(url, request, null, true, true);
}

export function fetchHolidayPartialLocations(year?: string | number): Promise<any> {
  const url = year ? `/holidays/partial/locations?year=${encodeURIComponent(year)}` : `/holidays/partial/locations`;
  return api.get(url, true, true);
}

export default getHolidaysFullStartWorker;
